module.exports = __webpack_public_path__ + "static/media/test_import_without_formatting.bff212d1.csv";